import Location from './Location'

export default class Raleigh extends Location { }

Raleigh.defaultProps = {
    locationTown: "Raleigh",
    headInstructor: "Joel Geniesse, Soke",
    mapLink: "https://www.google.com/maps/place/Trinity+Park+Church/@35.7964209,-78.8035385,862m/data=!3m2!1e3!4b1!4m6!3m5!1s0x89acedf3ac54512d:0xc59ba1328734827e!8m2!3d35.7964166!4d-78.8009636!16s%2Fg%2F1tc_rwq9!5m1!1e1?entry=ttu&g_ep=EgoyMDI1MDIyNi4xIKXMDSoASAFQAw%3D%3D",
    locationName: "Raleigh, NC area",
    address1: "",
    address2: "",
    cityStateZip: "",
    classTimes:"Not currently accepting students",
    class1: "",
    class2: "",
    registrationStatus: "Email us to be added to our new student waiting list",
    registrationPrice: "",
    registrationMonthly: "",
    registrationOtherFamily: "",
    infoEmail: "mailto:info.raleigh@warriors-for-christ.com?subject=Warriors Martial Arts Classes",
    calendarLink: '',
    instructor: "/geniessej"
};
